<template>
    <div class="login-page" v-if="ready">
      <component :is="tab" :isM4500="isM4500" v-if="!isIframe"></component>
      <div class="notice-item flex-layout" v-else>
        <div class="flex-item center f18">{{ $t('login.notice') }}</div>
      </div>
    </div>
  </template>
  
  <script setup>
  import { ref, computed, onMounted, markRaw, reactive, getCurrentInstance  } from "vue";
  import http from "./http.vue";
  import https from "./https.vue";


const state = reactive({
  component: markRaw(http), // Prevents reactivity
});

const $api = getCurrentInstance()?.appContext.config.globalProperties.$api
  
  // Reactive state variables
  const tab = ref("");
  const isM4500 = ref(false);
  const isIframe = ref(false);
  const ready = ref(false);
  
  // Initialize function (Replaces `created()`)
  const init = () => {
      $api.common.queryDeviceXml().then((json) => {
        ready.value = true;
        isM4500.value = json.includes("M4500");
      })
      ready.value = true;
  };
  
  // Lifecycle hook (Replaces `created()`)
  onMounted(() => {
    isIframe.value = self !== top;
    const { protocol } = location;
    // tab.value = protocol === "http:" ? http : https;
    tab.value = protocol === "http:" ? http : https;
    init();
  });
  </script>
  
  <style scoped>
  .login-page {
    height: 100vh;
  }
  .notice-item {
    height: 100%;
    align-items: center;
  }
  </style>
  